import { Tag } from 'antd'
import { severityStyles } from 'pages/pointClouds/components/dropdowns/EnumStyles'
import React from 'react'
import { ObservationType, Severity, TicketStatus } from 'types'

interface TicketStatusTagProps {
  status?: TicketStatus
}

interface SeverityTagProps {
  severity?: Severity
}

interface ObservationTypeTagProps {
  type?: ObservationType
}

export const SeverityTag: React.FC<SeverityTagProps> = ({ severity }) => {
  if (!severity) return null

  return (
    <Tag
      style={{
        backgroundColor: severityStyles[severity]?.color || '#666',
        color: 'white',
      }}>
      {severity}
    </Tag>
  )
}

export const ObservationTypeTag: React.FC<ObservationTypeTagProps> = ({
  type,
}) => {
  if (!type) return null

  return (
    <Tag
      style={{
        backgroundColor: '#666',
        color: 'white',
      }}>
      {type}
    </Tag>
  )
}

export const TicketStatusTag: React.FC<TicketStatusTagProps> = ({ status }) => {
  if (!status) return null

  const getTicketColor = (status: string) => {
    switch (status) {
      case TicketStatus.NEW:
        return '#AD7F35'
      case TicketStatus.OPEN:
        return 'green'
      default:
        return 'gray'
    }
  }

  return (
    <Tag
      style={{
        backgroundColor: getTicketColor(status),
        color: 'white',
      }}>
      {status}
    </Tag>
  )
}
